<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <template v-slot:default="{ open }">
        <v-row no-gutters>
          <v-col cols="3">Fuente de datos {{ schedule_id == 0 ? '' : schedule_id }}</v-col>
          <v-col
            cols="9"
          >
            <v-fade-transition leave-absolute>
              <span
                v-if="!open"
                key="1"
              >
                <small>
                  {{ "Extracción de "+n_fuente_datos+n_tipo_extraccion+", desde "+customFormatter(fechas[0])+(data_sch_type==4 ? "." : ", hasta "+customFormatter(fechas[1]))}}
                </small>
              </span>
            </v-fade-transition>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card color="#dddae4" class="schedule-card" light>
        <v-container>
          <v-row class="my-1 mx-2">
            <v-col md="12">
              <label class="form-label">Seleccione la fuente de datos</label><br/>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :color="(data_source_id==1 ? '#1da1f2':'')"
                    :dark="data_source_id==1"
                    :depressed="data_source_id==1"
                    @click="dataSourceSelected(1)"
                    class="mx-2 my-1"
                    style="padding-left:0; padding-right:0"
                    x-large
                    min-width="60"
                    max-width="60"
                    v-on="on"
                  >
                    <v-icon center large class="px-0">
                      mdi-twitter
                    </v-icon>
                  </v-btn>
                </template>
                <span>Twitter</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="dataSourceSelected(2)"
                    :color="(data_source_id==2 ? '#F28F05':'')"
                    :dark="data_source_id==2"
                    :depressed="data_source_id==2"
                    class="mx-2 my-1 px-1"
                    style="padding-left:0; padding-right:0"
                    min-width="60"
                    max-width="60"
                    x-large
                    v-on="on"
                  >
                    <v-icon center large class="px-0">
                      mdi-newspaper-variant-multiple
                    </v-icon>
                  </v-btn>
                </template>
                <span>Noticias</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="dataSourceSelected(3)"
                    :color="(data_source_id==3 ? '#1CE88A':'')"
                    :dark="data_source_id==3"
                    :depressed="data_source_id==3"
                    class="mx-2 my-1 px-1"
                    style="padding-left:0; padding-right:0"
                    min-width="60"
                    max-width="60"
                    x-large
                    v-on="on"
                  >
                    <v-icon center large class="px-0">
                      mdi-microphone
                    </v-icon>
                  </v-btn>
                </template>
                <span>Audio</span>
              </v-tooltip>
            </v-col>
            <template v-if="data_source_id!=null">
              <template v-if="data_source_id==1">
                <v-col md="5" class="py-0" >
                  <div class="form-group">
                    <label class="form-label">Elija el tipo de extracción</label>
                    <v-select :items="process_types" item-value="id" item-text="text" v-model="process_type_id" hide-details class="py-0"></v-select>
                    <div class="invalid-feedback">No, you missed this one.</div>
                  </div>
                </v-col>
                <v-col md="7"></v-col>
              </template>
              <v-col md="12" v-if="process_type_id==1 || process_type_id==2">
                <Words ref="words" :process_id="process_id" :schedule_id="schedule_id" :process_type_id="process_type_id"/>
              </v-col>
              <v-col md="12" v-show="data_source_id==2">
                <UrlDepth v-for="(url,index) in urls" :key="'urls_depth'+index" :url="url.url" :depth="url.depth" :index="index" @save_url="save_url"></UrlDepth>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      color="accent"
                      @click="add_url"
                    ><v-icon>
                      mdi-plus-box
                    </v-icon></v-btn>
                  </template>
                  <span>Agregar url</span>
                </v-tooltip>
              </v-col>

              <template v-show="process_type_id!=null">
                <v-col md="12">
                  <label class="form-label">Seleccione un formato de agendamiento</label><br/>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="(data_sch_type==1 ? 'secondary':'')"
                        :dark="data_sch_type==1"
                        :depressed="data_sch_type==1"
                        @click="data_sch_type=1"
                        class="mx-2 my-1"
                        style="padding-left:0; padding-right:0"
                        x-large
                        min-width="60"
                        max-width="60"
                        v-on="on"
                      >
                        <v-icon center large class="px-0">
                          mdi-calendar-today
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Un Día</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="(data_sch_type==2 ? 'secondary':'')"
                        :dark="data_sch_type==2"
                        :depressed="data_sch_type==2"
                        @click="mes=null; data_sch_type=2"
                        class="mx-2 my-1"
                        style="padding-left:0; padding-right:0"
                        x-large
                        min-width="60"
                        max-width="60"
                        v-on="on"
                      >
                        <v-icon center large class="px-0">
                          mdi-calendar-range
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Un Mes</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="(data_sch_type==3 ? 'secondary':'')"
                        :dark="data_sch_type==3"
                        :depressed="data_sch_type==3"
                        @click="data_sch_type=3"
                        class="mx-2 my-1"
                        style="padding-left:0; padding-right:0"
                        x-large
                        min-width="60"
                        max-width="60"
                        v-on="on"
                      >
                        <v-icon center large class="px-0">
                          mdi-calendar-question
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Personalizado</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="(data_sch_type==4 ? 'secondary':'')"
                        :dark="data_sch_type==4"
                        :depressed="data_sch_type==4"
                        @click="data_sch_type=4; fechas=[new Date(),new Date('2030-12-01')]"
                        class="mx-2 my-1"
                        style="padding-left:0; padding-right:0"
                        x-large
                        min-width="60"
                        max-width="60"
                        v-on="on"
                      >
                        <v-icon center class="px-0">
                          mdi-calendar-blank
                        </v-icon>
                        <v-icon center small class="px-0">
                          mdi-arrow-right
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Continuo<br>(De ahora en adelante)</span>
                  </v-tooltip>
                </v-col>
              </template>

              <template v-if="data_sch_type==1">
                <v-col md="6">
                  <label class="form-label">Seleccione la fecha</label><br/>
                  <v-menu
                    bottom
                    left
                    v-model="menuDia"
                    light
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateRangeTextDia"
                        prepend-icon="mdi-calendar"
                        readonly
                        class="pt-0"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-card>
                      <v-date-picker
                        v-model="fecha"
                        no-title
                        @change="seleccion_fecha_dia"
                      ></v-date-picker>
                    </v-card>
                  </v-menu>
                </v-col>
              </template>

              <template v-if="data_sch_type==2">
                <v-col md="6">
                  <label class="form-label">Seleccione el mes</label><br/>
                  <v-menu
                    bottom
                    left
                    v-model="menuMes"
                    light
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateRangeTextMes"
                        readonly
                        class="pt-0"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-card>
                      <v-date-picker
                        v-model="mes"
                        type="month"
                        no-title
                        @change="seleccion_fecha_mes"
                      ></v-date-picker>
                    </v-card>
                  </v-menu>
                </v-col>
              </template>
              <template v-if="data_sch_type==3">
                <v-col md="6">
                  <label class="form-label">Seleccione la fecha inicial y la fecha final del periodo a analizar</label><br/>
                  <v-menu
                    bottom
                    left
                    v-model="menuPer"
                    light
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateRangeTextPer"
                        readonly
                        class="pt-0"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-card>
                      <v-date-picker
                        v-model="fechasPer"
                        range
                        no-title
                        @change="seleccion_fecha_per"
                      ></v-date-picker>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menuPer = false"
                        >
                          OK
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-col>
              </template>
              <template v-if="data_sch_type==4">
                <v-col md="6">
                  <div class="form-group">
                    <label class="form-label pl-3 pb-2">Frecuencia de Ejecucion</label>
                    <input type="hidden"  value="">
                    <div id="chk_proceso-frecuencia_ejecucion" class="d-flex flex-row pl-3">
                      <div class="px-2 text-center">
                        <label for="todos">Diario</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="todos" value="todos" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="lunes">Lunes</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="lunes" value="lunes" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="martes">Martes</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="martes" value="martes" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="miercoles">Miercoles</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="miercoles" value="miercoles" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="jueves">Jueves</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="jueves" value="jueves" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="viernes">Viernes</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="viernes" value="viernes" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="sabado">Sabado</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="sabado" value="sabado" v-model="frecuency">
                      </div>
                      <div class="px-2 text-center">
                        <label for="domingo">Domingo</label><br>
                        <input v-on:click="chkFrenquency" class="mx-1" type="checkbox" id="domingo" value="domingo" v-model="frecuency">
                      </div>
                    </div>
                    <div v-show="mostrar_mensaje_error_frecuencia">No ha seleccionado una frecuencia</div>
                  </div>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-container>
        <v-card-actions v-if="data_source_id!=null">
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                @click="check_schedule"
                color="accent"
                v-on="on"
              >
                <v-icon>
                  mdi-content-save
                </v-icon>
              </v-btn>
            </template>
            <span>Guardar</span>
          </v-tooltip>
          <v-tooltip top v-show="this.schedule_id!='0'">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                @click="runSchedule"
                color="warning"
                v-on="on"
              >
                <v-icon>
                  mdi-play-box-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Ejecutar</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>
import store from '@/store';
import apiExtract from "@/api/modules/extract";
import moment from 'moment';
import UrlDepth from '@/components/schedule/UrlDepth.vue';
import Words from '@/components/schedule/Words.vue';

let organization_id = store.getters['auth/org'];
export default {
  components:{
    Words,
    UrlDepth,
  },
  props: {
    schedule_id: {
      type: Number,
      default: 0
    },
    process_id: {
      type:String,
      default:"0"
    }
  },
  computed:{
    n_fuente_datos(){
      if (this.data_source_id==1) {
        return "Twitter";
      }else if (this.data_source_id==2) {
        return "páginas web";
      }else if (this.data_source_id==3) {
        return "radio";
      }return "";
    },
    n_tipo_extraccion(){
      if (this.process_type_id==1) {
        return " por usuario(s) "+this.palabras
      }else if (this.process_type_id==2) {
        return " por combinación de palabras "+this.palabras
      }else if (this.process_type_id==3) {
        return " "+this.palabras.slice(0,40)+"... " 
      }return "";
    }
  },
  mounted(){
    if (this.schedule_id!="0") {
      apiExtract.getSchedule(organization_id, this.schedule_id)
      .then((resp)=>{
        this.data_source_id = resp.schedule.red_social_id;
        this.process_type_id = resp.schedule.tipo_proceso_id;
        this.fechas[0] = moment(resp.schedule.fecha_inicio, 'DD/MM/YYYY').format();
        this.fechas[1] = moment(resp.schedule.fecha_fin, 'DD/MM/YYYY').format();
        if (resp.schedule.frecuencia_ejecucion.length > 0) {
          this.frecuency=resp.schedule.frecuencia_ejecucion.split(",");
        }else{
          this.frecuency=[]
        }
        if(this.fechas[0]==this.fechas[1]){
          this.data_sch_type=1
          this.fecha = this.fechas[0]
          this.dateRangeTextDia = this.customFormatter(this.fecha)
        }else if (this.fechas[1].slice(0,4)=="2030") {
          this.data_sch_type=4
        }else if(this.fechas[0].slice(8,10)=="01") {
          if (["01","03","05","08","10","12"].includes(this.fechas[1].slice(5,7))) {
            if (this.fechas[1].slice(8,10)=="31") {
              this.data_sch_type=2
              this.mes = this.fechas[0].slice(0,7)
              this.dateRangeTextMes = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
            }else{
              this.data_sch_type=3
              this.fechasPer = this.fechas
              this.dateRangeTextPer = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
            }
          }else if (["04","06","07","09","11"].includes(this.fechas[1].slice(5,7))) {
            if (this.fechas[1].slice(8,10)=="30") {
              this.data_sch_type=2
              this.mes = this.fechas[0].slice(0,7)
              this.dateRangeTextMes = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
            }else{
              this.data_sch_type=3
              this.fechasPer = this.fechas
              this.dateRangeTextPer = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
            }
          }else {
            if (Number(this.fechas[1].slice(0,4))%4 == 0) {
              if (this.fechas[1].slice(8,10)=="29") {
                this.data_sch_type=2
                this.mes = this.fechas[0].slice(0,7)
                this.dateRangeTextMes = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
              }else {
                this.data_sch_type=3
                this.dateRangeTextPer = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
                this.fechasPer = this.fechas
              }
            }else {
              if (this.fechas[1].slice(8,10)=="28") {
                this.data_sch_type=2
                this.mes = this.fechas[0].slice(0,7)
                this.dateRangeTextMes = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
              }else {
                this.data_sch_type=3
                this.dateRangeTextPer = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
                this.fechasPer = this.fechas
              }
            }
          }
        }else {
          this.data_sch_type=3
          this.fechasPer = this.fechas
          this.dateRangeTextPer = this.customFormatter(this.fechas[0]) +" ~ "+ this.customFormatter(this.fechas[1])
        }
        this.urls = []
        resp.schedule.seeds.split(",").forEach((item) => {
          if (item!="") {
            this.urls.push({url:item,depth:resp.schedule.depth})
          }
        });
        this.palabras = this.urls[0].url
        apiExtract.getProcess_type(this.data_source_id)
          .then((resp)=>{
            if(resp.status){
              this.process_types = resp.process_type;
            }
        })
        apiExtract.getWords(organization_id, this.schedule_id)
        .then((resp)=>{
            this.processWords(resp);
        })
      })
    }
  },
  data(){
    return {
      users: null,
      words: null,
      palabras: "",
      menuDia:false,
      menuMes:false,
      menuPer:false,
      data_source_id:null,
      process_type_id:null,
      texto_complementario: "",
      data_sch_type:0,
      fechas:[new Date().toISOString().substr(0, 10),new Date().toISOString().substr(0, 10)],
      fecha:new Date().toISOString().substr(0, 10),
      fechasPer:[new Date().toISOString().substr(0, 10),new Date().toISOString().substr(0, 10)],
      mes:new Date().toISOString().substr(0, 10),
      dateRangeTextMes:this.customFormatter(new Date().toISOString().substr(0, 10)) + " ~ " +this.customFormatter(new Date().toISOString().substr(0, 10)),
      dateRangeTextDia:this.customFormatter(new Date().toISOString().substr(0, 10)),
      dateRangeTextPer:this.customFormatter(new Date().toISOString().substr(0, 10)) + " ~ " +this.customFormatter(new Date().toISOString().substr(0, 10)),
      frecuency: [],
      process_created:false,
      schedule_checked:false,
      urls: [],
      depth:0,
      process_types: [],
      mostrar_mensaje_error_frecuencia:false,
      data_sources: [
        {
          fecha_creacion:"Thu, 12 Sep 2019 15:05:49 GMT",
          id:1,
          text:"Twitter",
        },
        {
          fecha_creacion:"Thu, 12 Sep 2019 15:05:49 GMT",
          id:2,
          text:"Páginas web"
        }
      ],
    }
  },
  methods:{
    seleccion_fecha_per(){
      if (this.fechasPer[0]>this.fechasPer[1]) {
        this.fechas[0] = this.fechasPer[1]
        this.fechas[1] = this.fechasPer[0]
      }
      else {
        this.fechas[0] = this.fechasPer[0]
        this.fechas[1] = this.fechasPer[1]
      }
      this.dateRangeTextPer = this.customFormatter(this.fechas[0])+" ~ "+this.customFormatter(this.fechas[1]);
    },
    seleccion_fecha_dia(){
      this.fechas[1] = this.fecha
      this.fechas[0] = this.fecha
      this.dateRangeTextDia = this.customFormatter(this.fechas[0]);
    },
    seleccion_fecha_mes(){
      let ff;
      if (["01","03","05","08","10","12"].includes(this.mes.slice(5,7))) {
        ff=moment(this.mes+"-31", 'YYYY-MM-DD').format();
      }else if (["04","06","07","09","11"].includes(this.mes.slice(5,7))) {
        ff=moment(this.mes+"-30", 'YYYY-MM-DD').format();
      }else {
        if (Number(this.mes.slice(0,4))%4 == 0) {
          ff=moment(this.mes+"-29", 'YYYY-MM-DD').format();
        }else {
          ff=moment(this.mes+"-28", 'YYYY-MM-DD').format();
        }
      }
      this.fechas=[moment(this.mes+"-01", 'YYYY-MM-DD').format(),ff]
      this.dateRangeTextMes = this.customFormatter(this.fechas[0]) + " ~ " +this.customFormatter(this.fechas[1])
    },
    chkFrenquency: function (event) {
        this.determineDays(event);
    },
    startDateSelected(date){
        this.fechas[0] = moment(date).format();
        this.determineDays(null);
    },
    endDateSelected(date){
        this.fechas[1] = moment(date).format();
        this.determineDays(null);
    },
    arrayRemove(arr, value) {
        return arr.filter(function(ele)
            { return ele != value; }
        );
    },
    add_url(){
      this.urls.push({url:'',depth:0})
    },
    save_url(index,url,depth){
      this.urls[index].url=url;
      this.urls[index].depth=depth;
    },
    determineDays(e){
        if (e != null && e.target.value == 'todos' && !e.target.checked)
        {
            this.frecuency = [];
        }
        if (e != null && e.target.value == 'todos' && e.target.checked)
        {
            this.frecuency = ["todos","lunes","martes","miercoles","jueves","viernes","sabado","domingo"];
        }
        if (this.fechas[0] != null && this.fechas[1] != null){
            var fecha_ini = this.fechas[0];
            var fecha_fin = this.fechas[1];
            var fecha_ini_date = new Date(fecha_ini);
            var fecha_fin_date = new Date(fecha_fin);

            var hayLunes = false;
            var hayMartes = false;
            var hayMiercoles = false;
            var hayJueves = false;
            var hayViernes = false;
            var haySabado = false;
            var hayDomingo = false;

            for (var d = fecha_ini_date; d <= fecha_fin_date; d.setDate(d.getDate() + 1)) {
                var new_date = new Date(d);

                if (new_date.getDay() == 0)
                {
                    hayDomingo  = true;
                    //nueva_frecuencia.push("domingo");
                }
                if (new_date.getDay() == 1)
                {
                    hayLunes  = true;
                    //nueva_frecuencia.push("lunes");
                }
                if (new_date.getDay() == 2)
                {
                    hayMartes  = true;
                    //nueva_frecuencia.push("martes");
                }
                if (new_date.getDay() == 3)
                {
                    hayMiercoles  = true;
                    //nueva_frecuencia.push("miercoles");
                }
                if (new_date.getDay() == 4)
                {
                    hayJueves  = true;
                    //nueva_frecuencia.push("jueves");
                }
                if (new_date.getDay() == 5)
                {
                    hayViernes  = true;
                    //nueva_frecuencia.push("viernes");
                }
                if (new_date.getDay() == 6)
                {
                    haySabado  = true;
                    //nueva_frecuencia.push("sabado");
                }
                if (hayLunes && hayMartes && hayMiercoles && hayJueves && hayViernes && haySabado && hayDomingo)
                {
                    //nueva_frecuencia.push("todos");
                    break;
                }

            }
            if (!hayDomingo)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "domingo");
                if (e != null && e.target.value == 'domingo')
                {
                    e.preventDefault();
                }
            }
            if (!hayLunes)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "lunes");
                if (e != null && e.target.value == 'lunes')
                {
                    e.preventDefault();
                }
            }
            if (!hayMartes)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "martes");
                if (e != null && e.target.value == 'martes')
                {
                    e.preventDefault();
                }
            }
            if (!hayMiercoles)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "miercoles");
                if (e != null && e.target.value == 'miercoles')
                {
                    e.preventDefault();
                }
            }
            if (!hayJueves)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "jueves");
                if (e != null && e.target.value == 'jueves')
                {
                    e.preventDefault();
                }
            }
            if (!hayViernes)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "viernes");
                if (e != null && e.target.value == 'viernes')
                {
                    e.preventDefault();
                }
            }
            if (!haySabado)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "sabado");
                if (e != null && e.target.value == 'sabado')
                {
                    e.preventDefault();
                }
            }

            var hayTodos = false;
            if (hayLunes && hayMartes && hayMiercoles && hayJueves && hayViernes && haySabado && hayDomingo)
            {
                hayTodos = true;
                if (!this.frecuency.includes("todos")){
                    this.frecuency.push("todos");
                }
            }

            if (e != null && e.target.value == 'todos' && !hayTodos)
            {
                this.frecuency = this.arrayRemove(this.frecuency, "todos");
                e.preventDefault();
            }
        }
        else{
            this.frecuency = [];
            if (e != null)
            {
                e.preventDefault();
            }
        }
    },
    check_schedule () {
      if (this.data_sch_type!=4) {
        this.frecuency=["lunes","martes","miercoles","jueves","viernes","sabado","domingo"]
      }
      if(this.schedule_id!="0"){
        if (this.frecuency.length>0) {
          apiExtract.putSchedule(organization_id, this.schedule_id, this.process_id, this.data_source_id, this.process_type_id, this.fechas[0], this.fechas[1], this.frecuency, this.urls)
          .then(()=>{
              alert("Guardado satisfactoriamente");
          })
          .catch((err)=>{
              console.log(err);
          })
        }else{
          this.mostrar_mensaje_error_frecuencia=true
        }
       }else{
         if (this.frecuency.length>0) {
           apiExtract.postSchedule(organization_id, this.schedule_id, this.process_id, this.data_source_id, this.process_type_id, this.fechas[0], this.fechas[1], this.frecuency, this.urls)
           .then((val)=>{
               alert("Guardado satisfactoriamente");
               this.schedule_checked=true;
               if(this.data_source_id==1){
                 this.$refs.words.save_words(this.process_id,val.id)
               }
           })
           .catch((err)=>{
               console.log(err);
           })
         }else{
           this.mostrar_mensaje_error_frecuencia=true
         }
      }
    },

    dataSourceSelected(data_source_id){
      this.data_source_id=data_source_id
      this.process_type_id = null;
      this.urls=[]
      if(data_source_id==2){
        this.process_type_id = 3;
        this.urls=[{url:'',depth:0}]
      }
      apiExtract.getProcess_type(data_source_id)
        .then((resp)=>{
          if(resp.status){
            this.process_type_id=null;
            this.process_types = resp.process_type;
            if (data_source_id==2) {
              this.process_type_id=3;
            }
          }
      })
    },

    customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
    },

    runSchedule(){
        apiExtract.putRunSchedule(organization_id, this.schedule_id)
        .then(()=>{
            alert("Ejecutado satisfactoriamente");
        })
    },
    processWords(resp){
      var functionWords = [];
      var parents = [];
      var childs = [];
      let count = 0;
      if(resp.status){
        if(this.process_type_id==1){
          this.users = resp.words;
          this.palabras = "@"+this.users[0].palabra+(this.users.length>1 ? "..." : "");
        }
        if(this.process_type_id==2){
          resp.words.forEach(element => {
            if(element.tipo_palabra_id==2){
              parents.push({id:element.id, word:element.palabra});
            }
            if(element.tipo_palabra_id==3){
              childs.push({id:element.id, word:element.palabra});
            }
          });
          count = (childs.length > parents.length)?childs.length:parents.length;
          for (let index = 0; index < count; index++) {
            functionWords.push({parent_id: (typeof parents[index] !== 'undefined')?parents[index]['id']:null, parent:(typeof parents[index] !== 'undefined')?parents[index]['word']:null, child_id: (typeof childs[index] !== 'undefined')?childs[index]['id']:null, child:(typeof childs[index] !== 'undefined')?childs[index]['word']:null})
          }
        }
        this.words = functionWords;
        this.palabras = "("+this.words[0].parent+(this.words[0].child != null ? ","+this.words[0].child : "" )+(this.words.length > 1 ? "..." : "" )+")";
      }
    }
  }
}
</script>

<style>
.schedule-card{
  background: #dddae4;
  border-radius: 10px;
}
</style>
